<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-gray-800 text-xl font-bold">Settings</h6>
        <button @click="save" class="rouanded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300" type="button">Save settings</button>
      </div>
    </div>
    <div v-if="currentUser.type && currentUser.type !== 'Seller'" class="flex-auto px-4 lg:px-10 py-10 pt-0 relative">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Order fees</h6>
        <div class="flex flex-wrap">
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Confirmaion fees <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></label>
              <input type="number" v-model="detail.order.feesConfirmation" min="0" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            </div>
          </div>
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Order fees <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></label>
              <input type="number" v-model="detail.order.fees" min="0" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            </div>
          </div>
        </div>
        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Shipping fees</h6>
        <div class="flex flex-wrap">
            <div class="w-full lg:w-4/12 px-4">
               <div class="relative w-full mb-3">
                  <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Shipping fees <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></label>
                  <input type="number" v-model="detail.shipping.fees" min="0" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
                </div>
            </div>
            <div class="w-full lg:w-4/12 px-4">
               <div class="relative w-full mb-3">
                  <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Shipping refund <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></label>
                  <input type="number" v-model="detail.shipping.refund" min="0" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
                </div>
            </div>
            <div class="w-full lg:w-4/12 px-4">
               <div class="relative w-full mb-3">
                  <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Shipping change <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></label>
                  <input type="number" v-model="detail.shipping.change" min="0" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
                </div>
            </div>
        </div>
        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Services fees</h6>
         <div class="w-full lg:w-4/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Services fees <sup>(%)</sup></label>
                 <div class="flex flex-wrap items-stretch w-full relative bg-white items-center rounded mb-4 shadow">
                <input type="number" v-model="detail.services_fees" class="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 px-3 py-3 relative self-center font-roboto text-sm placeholder-gray-400 text-gray-700 bg-white outline-none" min="0">
                <div class="flex -mr-px">
                  <span class="flex items-center leading-normal bg-white rounded rounded-l-none border-0 px-3 whitespace-no-wrap text-gray-600">
                    %
                    </span>
                </div>
              </div>
              </div>
          </div>
        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Subscription fees</h6>
        <div class="flex flex-wrap">
          <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Subscription fees <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></label>
              <input type="number" v-model="detail.subscription_fees" min="0" class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
            </div>
          </div>
        </div>
        <!-- <hr class="mt-6 border-b-1 border-gray-400">
          <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Phone</h6>
          <div class="flex flex-wrap">
            <div class="w-full lg:w-4/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Phone</label>
                <input type="text" v-model="detail.phone"  class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">
              </div>
            </div>
        </div> -->
         <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Blacklist phone number</h6>
        <div class="flex flex-wrap">
          <div class="w-full  px-4">
            <div class="relative w-full my-3">
             <div class="border  border-gray-500  transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p><label for="cities" class="bg-gray-200 text-gray-700 px-1  uppercase text-xs font-bold">Add phone <img v-if="idWharhouse && idWharhouse.flag" class="h-4 w-5 inline-block ml-2" :src="idWharhouse.flag"   /></label></p>
                  </div>
                  <div id="city" class="md:w-full overflow-y-auto h-full flex flex-col items-center p-1">
                    <div class="w-full">
                      <div class="flex flex-col items-center relative">
                        <div class="w-full">
                          <div class="mt-2 mb-4 p-1 bg-white flex border border-gray-200 rounded">
                            <div class="flex flex-auto flex-wrap"></div>
                            <input
                              v-model="phoneInput"
                              @keyup.enter="trigger"
                              placeholder="Enter phone"
                              class="p-1 px-2 appearance-none outline-none w-full text-gray-800"
                            />
                            <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
                              <button @click="addPhones" ref="sendReply" class="cursor-pointer w-6 h-6 text-blue-500 outline-none focus:outline-none"><i class="material-icons">add</i></button>
                            </div>
                          </div>
                        </div>
                        <!-- Displaying cities -->
                        <div
                          v-if="formData.blacklist_phones.length > 0"
                          class="tag_cities"
                        >
                          <span
                            v-for="(city, index) in formData.blacklist_phones"
                            :key="index"
                            class="tag label label-info"
                          >
                            <span class="text-chip vs-chip--text">{{
                              city
                            }}</span>
                            <span
                              class="btn-close vs-chip--close"
                              @click="deletePhone(index)"
                              data-role="remove"
                            ></span>
                          </span>
                        </div>
                        <div v-else class="py-2">
                          <span
                            class="w-full flex justify-center text-center border-gray-200 text-base"
                            ><p
                              class="font-semibold flex text-blue-500 whitespace-no-wrap"
                            >
                              <span>No Phone added </span>
                            </p></span
                          >
                        </div>
                        <!-- / Displaying cities -->
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <!--<hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">TVA</h6>
         <div class="flex flex-wrap">
          <div
                  class="border border-gray-400 lg:w-4/12 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                >
                  <div
                    class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                  >
                    <p>
                      <label for="cities" class="block  bg-gray-200 uppercase text-gray-700 text-xs font-bold mb-2"
                        >Tva list<span :class="$colors.required">
                          *</span
                        ></label
                      >
                    </p>
                  </div>
                  <div
                    id="tva"
                    class="md:w-full overflow-y-auto h-full flex flex-col items-center p-1"
                  >
                    <div class="w-full">
                      <div class="flex flex-col items-center relative">
                        <div class="w-full">
                          <div
                            class="mt-2 shadow  mb-2 p-1 bg-white flex border border-gray-200 rounded"
                          >
                            <div class="flex flex-auto flex-wrap"></div>
                            <input
                              v-model="tvaInput"
                              @keyup.enter="trigger"
                              placeholder="Enter tva (%)"
                              class="p-1 px-2 appearance-none outline-none w-full text-gray-800"
                            />
                            <div
                              class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200"
                            >
                              <button
                                @click="addTva"
                                ref="sendReply"
                                class="cursor-pointer w-6 h-6 text-blue-500 outline-none focus:outline-none"
                              >
                                <i class="material-icons">add</i>
                              </button>
                            </div>
                          </div>
                        </div>
                        
                        <div
                          v-if="formData.tva.length > 0"
                          class="w-full max-height-200"
                        >
                          <div
                            v-for="(t, index) in formData.tva"
                            :key="index"
                            class="flex cursor-pointer my-1 hover:bg-blue-lightest rounded"
                          >
                              <div class="w-8 h-10 text-center py-1 hori-center">
                                <p class="text-3xl p-0 text-grey-dark">•</p>
                              </div>
                              <div class="w-4/5 h-10 py-3 px-1">
                                <p class="hover:text-blue-dark">{{t}} %</p>
                              </div>
                              <div class="w-1/5 h-10 text-right p-3">
                                <p  @click="deleteTva(index)"  class="btn-close vs-chip--close" data-role="remove"></p>
                              </div>
                        
                          </div>
                        </div>
                        <div v-else class="py-2">
                          <span
                            class="w-full flex justify-center text-center border-gray-200 text-base"
                            ><p
                              class="font-semibold flex text-blue-500 whitespace-no-wrap"
                            >
                              <span>No Tva added </span>
                            </p></span
                          >
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
        </div>  -->
    </div>
    <div v-if="currentUser.type && currentUser.type == 'Seller'" class="flex-auto px-4 lg:px-10 py-10 pt-2 relative">
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">API</h6>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 xl:w-1/2 px-4">
               <div class="ant-col">
                <div class="ant-row">
                  <div class="ant-label">
                    <label for="key" class="ant-form" title="identité du client">API key</label>
                  </div>
                  <div class="ant-col ant-form-item">
                    <div class="ant-form-item-control has-success">
                      <span class="ant-form-item-children">
                        <span class="ant-input-group-wrapper">
                          <span class="ant-input-group"><input disabled="" id="key" class="ant-input ant-input-disabled"  type="text" :value="currentUser.api?currentUser.api.key:''">
                            <span @click="copyIt('key')" class="ant-input-group-addon">
                              <svg aria-hidden="true" data-prefix="fal" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0  hahmov" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="#5c6166"><path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"></path></svg>
                            </span>
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="w-full md:w-1/2 xl:w-1/2 px-4">
               <div class="ant-col">
                <div class="ant-row">
                  <div class="ant-label">
                    <label for="secret" class="ant-form" title="identité du client">API secret key</label>
                  </div>
                  <div class="ant-col ant-form-item">
                    <div class="ant-form-item-control has-success">
                      <span class="ant-form-item-children">
                        <span class="ant-input-group-wrapper">
                          <span @click="copyIt('secret')" class="ant-input-group"><input disabled="" id="secret" class="ant-input ant-input-disabled"  type="text" :value="currentUser.api?currentUser.api.secret:''">
                            <span  class="ant-input-group-addon">
                              <svg aria-hidden="true" data-prefix="fal" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0  hahmov" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" color="#5c6166"><path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"></path></svg>
                            </span>
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>  
        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Warehouses (Country code)</h6>
        <div class="container tag-rail">
         
          <div class="rail-container">
            <div class="rail" id="rail">
             <span v-for="(item, index) in currentUser.warehouses" :key="index" :id="'tag'+index" class="tag">  {{ item.countryName }} (<b>{{ item.country }}</b>)</span>
            </div>
          </div>
        
        </div>
        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Prefix order</h6>
        <div class="flex flex-wrap">
            <div v-for="(item) in currentUser.prefixs" class="w-full lg:w-4/12 px-4"  >
              <div  class="border hover:border-green-500  hover:border-green-500  focus-within:border-blue-500 flex flex-wrap items-stretch w-full mb-2 relative h-15 bg-white items-center rounded">
                <div class="flex -mr-px justify-center p-1 pr-0">
                  <span class="flex border border-black items-center leading-normal bg-white px-3 border-0 rounded rounded-r-none text-sm font-bold text-gray-600">
                      <span class="select-none mr-2"> <img  class="flag-img" :src="$f.getCountryCode(item.country)"/></span> <span>{{ `${item.name}_XXXXX` }}</span>
                  </span>
                </div>
                <input type="text" placeholder="Prefix ..."  v-model="item.name" class="flex-shrink border border-black flex-grow flex-auto leading-normal w-px flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                <div class="flex -mr-px justify-center p-1">
                  <input type="text" placeholder="Country name ..."  v-model="item.countryName" class="flex border border-black items-center leading-normal flex-1 border-0 h-10 border-grey-light rounded rounded-l-none px-3 self-center relative outline-none">
                </div>
              </div>
            </div>
        </div>    
        

        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 mb-10 text-sm mt-3  font-bold uppercase">Services</h6>
        <div class="container-2 xpt-center">
            <div class="xpt">
                <div class="xpt-hex xpt-cw"> 
                  <div class="xpt-ihex">
                    <div class="xpt-box-inr">
                      <div class="xpt-box-1 xpt-center">
                        <h3 class="xpt-title"> Orders  <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></h3>
                        
                      </div>
                      <div class="xpt-box-2">
                        <ul class="xpt-body">  
                          <li>  <i class="material-icons">fiber_manual_record</i>CONFIRMAION FEES: {{ detail.order.feesConfirmation }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></li>
                          <li>  <i class="material-icons">fiber_manual_record</i>ORDER FEES: {{ detail.order.fees }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></li>
                        </ul><!-- /.xpt-body --> 
                      </div>
                    </div> 
                  </div>
                </div>
                <div class="xpt-hex"> 
                  <div class="xpt-ihex">
                    <div class="xpt-box-inr">
                      <div class="xpt-box-1 xpt-center">
                        <h3 class="xpt-title"> Shippings <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup> </h3>
                        
                      </div>
                      <div class="xpt-box-2">
                        <ul class="xpt-body">  
                          <li><i class="material-icons">fiber_manual_record</i>SHIPPING FEES: {{ detail.shipping.fees }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></li>
                          <li><i class="material-icons">fiber_manual_record</i>SHIPPING REFUND: {{ detail.shipping.refund }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></li>
                          <li><i class="material-icons">fiber_manual_record</i>SHIPPING CHANGE: {{ detail.shipping.change }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></li> 
                        </ul><!-- /.xpt-body --> 
                       
                      </div>
                    </div> 
                  </div>
				        </div>
                <div class="xpt-hex"> 
                  <div class="xpt-ihex">
                    <div class="xpt-box-inr">
                      <div class="xpt-box-1 xpt-center">
                        <h3 class="xpt-title"> SERVICES  <sup>(%)</sup></h3>
                        
                      </div>
                      <div class="xpt-box-2">
                        <ul class="xpt-body">  
                          <li>  <i class="material-icons">fiber_manual_record</i>SERVICES FEES: {{ detail.services_fees }} (%)</li>
                        </ul><!-- /.xpt-body --> 
                      </div>
                    </div> 
                  </div>
                </div>
                <div class="xpt-hex xpt-cw"> 
                  <div class="xpt-ihex">
                    <div class="xpt-box-inr">
                      <div class="xpt-box-1 xpt-center">
                        <h3 class="xpt-title"> SUBSCRIPTION  <sup v-if="idWharhouse">({{idWharhouse.currency}})</sup></h3>
                        
                      </div>
                      <div class="xpt-box-2">
                        <ul class="xpt-body">  
                          <li>  <i class="material-icons">fiber_manual_record</i>SUBSCRIPTION FEES: {{ detail.subscription_fees }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></li>
                        </ul><!-- /.xpt-body --> 
                      </div>
                    </div> 
                  </div>
                </div>
            </div>
        </div>
       
    </div>
  </div>
</template>

<script>
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const PNF = require('google-libphonenumber').PhoneNumberFormat;
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {
         details:[],
         tva:[],
         blacklist_phones:[]
      },
      detail:{
         shipping: {fees: 0,refund:0,change:0},
         order: {feesConfirmation: 0,fees:0},
         services_fees:0,
         subscription_fees:0,
         phone:''
      },
      loading:false,
      fullPage: false,
      tvaInput:"",
     // user: {role: {},},
      phoneInput: "",
    };
  },
  async mounted() {
   // await this.getUser();
    //await this.getwharhouseId();
    await this.getSettings();
  },
  computed: {
     warhouseSelected(){
       return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
    },
  },
  watch: {
      'warhouseSelected': async function(oldVal, newVal) {
            //await this.getwharhouseId();
          //  await this.getSettings();
      },
      'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.getSettings();
        }
  },
  methods: {
     trigger() {
      this.$refs.sendReply.click();
    },
    copyIt: function(id) {
        //console.log('id-----',id)
        document.getElementById(id).removeAttribute('disabled');  
        let copyInput = document.querySelector('#'+id);
      //  console.log('copueee-----',copyInput)
        copyInput.select();
        document.execCommand("copy");
        document.getElementById(id).setAttribute('disabled', true);
    },
    addPhones(index) {
      if (this.phoneInput === "" || this.phoneInput === null || this.phoneInput.value === 0) {
        alert(`Please enter phone in text box below !! `, "warning");
      }else {
        console.log(' this.phoneInput----', this.phoneInput)
         let tel = phoneUtil.parse(this.phoneInput.toString(), this.idWharhouse.country);
         tel=phoneUtil.format(tel, PNF.E164);
        this.formData.blacklist_phones.push(tel);
        this.phoneInput = "";
      }
    },
    deletePhone(index) {
      this.formData.blacklist_phones.splice(index, 1);
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.user = res.content;
      else this.user = [];
    },
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
    addTva() {
      if (this.tvaInput === "" || this.tvaInput === null || this.tvaInput.value === 0) {
        alert(`Please enter tva in text box below !! `, "warning");
      } else if(isNaN(this.tvaInput)){
            alert(`Please enter a number value`, "warning");
      }else {
        
        this.formData.tva.push(this.tvaInput);
        this.tvaInput = "";
      }
    },
    deleteTva(index) {
      this.formData.tva.splice(index, 1);
    },
    async save() {
      let data=null;
       if(this.currentUser.type === 'Seller'){
            data = await this.$server.update('users', {_id:this.currentUser._id,prefixs:this.currentUser.prefixs.filter(x => x.name || x.countryName)});
       }else{
          const currentSettingW=this.$f.getElementInArray(this.formData.details,this.idWharhouse);
          if(currentSettingW) this.$f.changeDataWarhouse(this.formData.details,this.idWharhouse._id,this.detail);
          else {
            this.detail.warehouse=this.idWharhouse;
            this.formData.details.push(this.detail);
          }
          data = await this.$server.update("settings", this.formData);
       }
       
        if (data && data._id) {
          await this.getSettings();
          alert("Setting updated", "success");
        }else alert(data, "warning");
    },
    async getSettings() {
        this.loading=true;
        const data = await this.$server.get("settings");
        this.formData = data.content;
        if(!this.formData.blacklist_phones) this.formData.blacklist_phones=[];
        console.log('check phone-------',this.formData.blacklist_phones.toString().indexOf("22570248264"));
        const currentSettingW=this.$f.getElementInArray(this.formData.details,this.idWharhouse);
        if(currentSettingW) this.detail = currentSettingW;
        else this.detail = {shipping: {fees: 0,refund:0,change:0},order: {feesConfirmation: 0,fees:0},services_fees:0}    
        this.loading=false;

        if(this.currentUser.type === 'Seller'){
          if(!this.currentUser.prefixs) this.currentUser.prefixs=[];
          this.currentUser.warehouses.forEach(arg => {
              var index = this.currentUser.prefixs.findIndex(x => x.country === arg.country)
              if (index === -1 && arg.is_primary) this.currentUser.prefixs.push({name:"",countryName:"",country:arg.country});
          });
        }

       
    },
  },
};
</script>

<style scoped>
.ant-row input:focus-visible + .ant-input-group-addon {
    outline: 2px solid rgb(72, 156, 248);
}
.ant-row {
  position: relative;
  height: auto;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  margin-bottom: 24px;
  zoom: 1;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}
.ant-label {
  display: inline-block;
  overflow: hidden;
  line-height: 39.9999px;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}
.ant-col {
  position: relative;
  min-height: 1px;
}
.ant-row label {
  position: relative;
}
.ant-label > label {
  color: rgba(0,0,0,.85);
}
.ant-form-item-control {
  position: relative;
  line-height: 40px;
  zoom: 1;
}
.ant-form-item-children {
  position: relative;
}
.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}
.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input[disabled] {
  background: rgb(247, 249, 250);
}
.ant-input-group > .ant-input:first-child{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-input{
  height: 40px;
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
  touch-action: manipulation;
  -webkit-appearance: none;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
  font-size: 14px;
  line-height: 1.5;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-input-group-addon:last-child{
  border-top-left-radius: 0;
border-bottom-left-radius: 0;
border-left: 0;
}
.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: #4d4d4d;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}
.ant-input-group-addon, .ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}
.ant-input-group-addon, .ant-input-group-wrap, .ant-input-group > .ant-input {
  display: table-cell;
}
.tag-rail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
}
.rail-container {
  overflow: hidden;
  height: 36px;
  padding-top: 6px;
  cursor: pointer;
  scroll-behavior: smooth;
}
.tag {
  background: #e3ebf7;
  border-radius: 8px;
  padding: 3px 8px 4px;
  margin: 5px 4px;
  color: #285192;
  font-weight: 500;
  user-select: none;
  border: 1px solid #e3ebf7;
  transition-duration: 0.25s;
  white-space: nowrap;
  border: 2px dashed #013179;
}
.tag:first-child {
  margin-left: 16px;
}
.tag:last-child {
  margin-right: 16px;
}
.tag:hover {
  background: #dce4f0;
}
.tag:active {
  background: #e3ebf7;
}
.tag-selected {
  background: #3b71ca;
  color: #fff;
  border: 1px solid #3b71ca;
}
.tag-selected:hover {
  background: #3265b9;
  color: #fff;
}
.tag-selected:active {
  background: #3b71ca;
  color: #fff;
}
.btn-left-con,
.btn-right-con {
  position: absolute;
}
.btn-right-con {
  right: 0;
}
.btn-left,
.btn-right {
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 100%;
  cursor: pointer;
  transition-duration: 0.25s;
  box-shadow: 0 0 16px 24px #fff;
  background: #fff;
}
.btn-left {
  margin-left: 2px;
}
.btn-right {
  margin-right: 2px;
}
.btn-left:hover,
.btn-right:hover {
  background: #f2f2f2;
}
.btn-left:active,
.btn-right:active {
  background: #d9d9d9;
}
.container-2 {
    max-width: 1140px;
    margin: auto;
    padding: 0 15px;
}
.xpt-center {
    text-align: center;
}

.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
.hori-center{
  display: flex;
    justify-content: center;
    align-items: center;
}
.vs-chip--close {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 0;
    margin: 0 4px;
    margin-left: 8px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.15);
    color: #fff;
    transition: all 0.3s ease;
}
.vs-chip--close:after {
    content: "x";
    padding: 0px 2px;
    margin-bottom: 3px;
    font-size: 15px;
}
.max-height-200{
  max-height: 200px;
}
.tag_cities{
  max-height: 19vh;
  overflow-y: scroll;
}
/* total width */
.tag_cities::-webkit-scrollbar {
    width:7px
}


/* scrollbar itself */
.tag_cities::-webkit-scrollbar-thumb {
    background-color:#babac0;
    border-radius:16px;
}
.dtag_cities::-webkit-scrollbar-thumb:hover {
    background-color:#a0a0a5;
    border:4px solid #f4f4f4
}

/* set button(top and bottom of the scrollbar) */
.dropdown_warhouse::-webkit-scrollbar-button {display:none}



.xpt *,
.xpt *:after,
.xpt *:before {
	-webkit-transition: all .25s  linear;
	   -moz-transition: all .25s  linear;
	    -ms-transition: all .25s  linear;
	     -o-transition: all .25s  linear;
	        transition: all .25s  linear;
}

/* 2 - General Styles End
---------------------------------------------------------------------- */



/* 3 - Hexagon Styles
---------------------------------------------------------------------- */
.xpt-hex {
	font-family: 'Lato', sans-serif;
	position: relative; 
	z-index: 0;
	color: #fff;
	display: inline-block;
	margin: 80px 5px 75px 5px;
}
.xpt-hex:after {
	content: "";
	position: absolute;  
	-webkit-transform: rotate(60deg);
	   -moz-transform: rotate(60deg);
	    -ms-transform: rotate(60deg);
	     -o-transform: rotate(60deg);
	        transform: rotate(60deg);
}
.xpt-hex:before {
	content: "";
	position: absolute; 
	-webkit-transform: rotate(-60deg);
	   -moz-transform: rotate(-60deg);
	    -ms-transform: rotate(-60deg);
	     -o-transform: rotate(-60deg);
	        transform: rotate(-60deg);
} 
.xpt-hex,
.xpt-hex:after,
.xpt-hex:before { 
	width: 250px;
	height: 143px;
	background: #fff;
	text-align: justify;
}
 

/* 3.1 - Inner Hexagon
--------------------------------------*/
.xpt-ihex {
	position: absolute; 
	z-index: 1;
	left: 12px;
	right: 12px;
	top: 6px;
	bottom: 6px; 
}
.xpt-ihex:after {
	content: "";
	position: absolute;  
	-webkit-transform: rotate(60deg);
	   -moz-transform: rotate(60deg);
	    -ms-transform: rotate(60deg);
	     -o-transform: rotate(60deg);
	        transform: rotate(60deg);
}
.xpt-ihex:before {
	content: "";
	position: absolute; 
	-webkit-transform: rotate(-60deg);
	   -moz-transform: rotate(-60deg);
	    -ms-transform: rotate(-60deg);
	     -o-transform: rotate(-60deg);
	        transform: rotate(-60deg);
}
.xpt-ihex,
.xpt-ihex:after,
.xpt-ihex:before { 
	background: #3182ce;
} 

.xpt-ihex:after,
.xpt-ihex:before {
	width: 100%;
    height: 100%;
}
.xpt-box-inr {
	z-index: 2;
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
}

/* 3.1 - Inner Hexagon End
--------------------------------------*/



/* 3.2 - Price Component
--------------------------------------*/ 
.xpt-box-1 {
	font-weight: 300; 
}
.xpt-title {
	font-size: 24px!important;
	font-family: 'Lato', sans-serif;
	margin: 0;
	padding: 0;
	font-weight: 300!important;
	text-transform: uppercase;
	margin-top: 43px!important;
}
.xpt-price-box {
	font-weight: 300!important;
	display: inline-block;
	position: relative;
}
.xpt-price {
	font-size: 90px;
	line-height: 60px;
}
.xpt-price span {
	position: absolute;
	left: 100%;
	font-size: 40px;
	top: -14px; 
}
.xpt-currency {
	position: absolute;
	left: -20px;
	top: -8px;
	font-size: 40px;
}
.xpt-duration {
	position: absolute;
	font-size: 20px;
	bottom: -30px;
	left: 0;
	right: 0;
}
.xpt-box-2 {
	position: absolute;
	left: 0;
	right: 0;
	top: 50px;
	opacity: 0;
	padding: 0 5px;
margin-top: 16px;
}
.xpt-fleft{
	text-align: left;
}
.xpt-fcenter{
	text-align: center;
}
.xpt-fright {
	text-align: right;
}
.xpt-body,
.xpt-body li {
	list-style: none;
	margin: 0!important;
	padding: 0;
}
.xpt-body li {
	line-height: 19px;
	font-size: 10px;
	padding: 4px 0;
	position: relative;
} 


/* Tool-tip */
.xpt-body li span {
	display: inline-block; 
	cursor: help; 
	border-bottom: dotted 2px #fff;
} 
.xpt-body li span:before {
	content: "";
	position: absolute;
	top: -15px;
	width: 12px;
	height: 12px;
	left: 50%;
	margin-left: -6px;  
}
.xpt-body li span i {
	margin:0; 
	margin-bottom: 15px; 
	position: absolute;
	bottom: 100%; 
	display: inline-block; 
    padding: 0 5px;
    border-radius: 3px;
    text-align: center;
    background: #3182ce;
    left: 0px;
    right: 0px;
}
.xpt-body li span:before,
.xpt-body li span i {  
	width: 0;
	height: 0;
	display: inline-block;
	overflow: hidden; 
	border:0;
}
.xpt-body li span:hover:before,
.xpt-body li span:hover i {
	opacity: 1; 
	width: auto;
	height: auto; 
	overflow: visible;
}  
.xpt-body li span:hover:before {
	top: 0; 
	border-width:6px;
	border-style: solid;
	border-color:#fff transparent transparent transparent;
}
.xpt-body li span:hover i {
	margin-bottom: 0;
	padding: 4px;
	border: 2px solid #fff;
}


/* Button */

.xpt-btn {
	font-size: 13px;
	display: inline-block;
	color: #fff!important;
	padding-top: 25px;
	text-decoration: none;
	box-shadow: none!important;
	text-transform: uppercase;
} 

.xpt-body li i,
.xpt-btn i {
	margin-right: 3px;
font-size: 10px;
vertical-align: unset;
}


/* 3.2 - Price Component End
--------------------------------------*/


/* 3.3 - Hover Effects
--------------------------------------*/
.xpt-hex:hover .xpt-box-1 {
	opacity: 0;
}
.xpt-hex:hover .xpt-box-2 {
	opacity: 1;
	top: 0;
}

.xpt-hex.xpt-cw:hover,
.xpt-hex.xpt-acw:hover .xpt-ihex {
	-webkit-transform: rotate(60deg);
	   -moz-transform: rotate(60deg);
	    -ms-transform: rotate(60deg);
	     -o-transform: rotate(60deg);
	        transform: rotate(60deg);
}

.xpt-hex.xpt-cw:hover .xpt-ihex,
.xpt-hex.xpt-acw:hover {
	-webkit-transform: rotate(-60deg);
	   -moz-transform: rotate(-60deg);
	    -ms-transform: rotate(-60deg);
	     -o-transform: rotate(-60deg);
	        transform: rotate(-60deg);
}
  
.xpt-hex.xpt-zoom:hover .xpt-ihex {
	-webkit-transform: scale(1.105,1.105);
	   -moz-transform: scale(1.105,1.105);
	    -ms-transform: scale(1.105,1.105);
	     -o-transform: scale(1.105,1.105);
	        transform: scale(1.105,1.105);
} 


.xpt-hex.xpt-zoom-out .xpt-ihex {
	-webkit-transform: scale(1.105,1.105);
	   -moz-transform: scale(1.105,1.105);
	    -ms-transform: scale(1.105,1.105);
	     -o-transform: scale(1.105,1.105);
	        transform: scale(1.105,1.105);
}

.xpt-hex.xpt-zoom-out:hover .xpt-ihex {
	-webkit-transform: scale(1,1);
	   -moz-transform: scale(1,1);
	    -ms-transform: scale(1,1);
	     -o-transform: scale(1,1);
	        transform: scale(1,1);
} 


.xpt-hex.xpt-inr-cw:hover .xpt-ihex .xpt-box-inr, 
.xpt-hex.xpt-inr-acw:hover .xpt-ihex,
.xpt-hex.xpt-acw.xpt-zoom:hover .xpt-box-inr{
	-webkit-transform: rotate(60deg);
	   -moz-transform: rotate(60deg);
	    -ms-transform: rotate(60deg);
	     -o-transform: rotate(60deg);
	        transform: rotate(60deg);
}

.xpt-hex.xpt-inr-cw:hover .xpt-ihex,
.xpt-hex.xpt-inr-acw:hover .xpt-ihex .xpt-box-inr,
.xpt-hex.xpt-cw.xpt-zoom:hover .xpt-box-inr {
	-webkit-transform: rotate(-60deg);
	   -moz-transform: rotate(-60deg);
	    -ms-transform: rotate(-60deg);
	     -o-transform: rotate(-60deg);
	        transform: rotate(-60deg);
}

.xpt-hex.xpt-clr-cng:hover,
.xpt-hex.xpt-clr-cng:hover:after,
.xpt-hex.xpt-clr-cng:hover:before {
	background:  #3182ce;
} 



.xpt-hex.xpt-flip {
	-webkit-perspective:1000;
	-moz-perspective:1000;
	-ms-perspective:1000;
	perspective: 1000;
}
.xpt-hex.xpt-flip .xpt-box-2,
.xpt-hex.xpt-zoom-in-out .xpt-box-2  {
	top: 0;
}
.xpt-hex.xpt-flip:hover .xpt-ihex ,
.xpt-hex.xpt-flip:hover .xpt-box-inr { 
	-webkit-transform: rotateY(180deg);
	   -moz-transform: rotateY(180deg);
	    -ms-transform: rotateY(180deg);
	     -o-transform: rotateY(180deg);
	        transform: rotateY(180deg);
}

.xpt-hex.xpt-flip.xpt-frl:hover .xpt-ihex ,
.xpt-hex.xpt-flip.xpt-frl:hover .xpt-box-inr { 
	-webkit-transform: rotateY(-180deg);
	   -moz-transform: rotateY(-180deg);
	    -ms-transform: rotateY(-180deg);
	     -o-transform: rotateY(-180deg);
	        transform: rotateY(-180deg);
} 

.xpt-hex.xpt-flip.xpt-ftb:hover .xpt-ihex ,
.xpt-hex.xpt-flip.xpt-ftb:hover .xpt-box-inr { 
	-webkit-transform: rotateX(-180deg);
	   -moz-transform: rotateX(-180deg);
	    -ms-transform: rotateX(-180deg);
	     -o-transform: rotateX(-180deg);
	        transform: rotateX(-180deg);
}

.xpt-hex.xpt-flip.xpt-fbt:hover .xpt-ihex ,
.xpt-hex.xpt-flip.xpt-fbt:hover .xpt-box-inr { 
	-webkit-transform: rotateX(180deg);
	   -moz-transform: rotateX(180deg);
	    -ms-transform: rotateX(180deg);
	     -o-transform: rotateX(180deg);
	        transform: rotateX(180deg);
} 
 
.xpt-hex.xpt-zoom-in-out:hover .xpt-ihex  {
	-webkit-animation: xptzoom-in-out .5s;  
    animation: xptzoom-in-out .5s;
}

@keyframes xptzoom-in-out {
    0% {
    		-webkit-transform: scale(1,1);
    		   -moz-transform: scale(1,1);
    		    -ms-transform: scale(1,1);
    		     -o-transform: scale(1,1);
    		        transform: scale(1,1);
    }
    50% {
    		-webkit-transform: scale(.4,.4);
    		   -moz-transform: scale(.4,.4);
    		    -ms-transform: scale(.4,.4);
    		     -o-transform: scale(.4,.4);
    		        transform: scale(.4,.4);
    } 
    100% {
    		-webkit-transform: scale(1,1);
    		   -moz-transform: scale(1,1);
    		    -ms-transform: scale(1,1);
    		     -o-transform: scale(1,1);
    		        transform: scale(1,1);
    }
}

</style>